import React from 'react';
import { BookOpenIcon, FlaskConicalIcon } from 'lucide-react';
import { Section } from './Shared';
import { Blossom } from './FloralDecor';
import { bonuses, tomes } from '../data/pack';
const tomeIcons = [BookOpenIcon, FlaskConicalIcon];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-216" data-mp="3m9nknp7jqzcz">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-217" data-mp="3ma5szk7hh419">
        <Blossom className="absolute right-[4%] top-10 h-24 w-24 text-brand-roseMist" data-id="element-218" data-mp="ducaiztldihk" />
        <Blossom className="absolute left-[3%] top-1/2 h-20 w-20 text-brand-lavenderMist" data-id="element-219" data-mp="irlysc58vo3t" />
      </div>

      <div className="mb-4 text-center" data-id="element-220" data-mp="43989uoxexgp">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-221" data-mp="9341w603615g">✨ Todos los niveles</p>
        <h2 className="font-display text-3xl font-bold text-brand-green md:text-5xl" data-id="element-222" data-mp="wsyauchab5kf">
          2 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <p className="mt-3 text-base text-brand-muted md:text-lg" data-id="element-223" data-mp="11kpus45xqd1l">
          Más de 150 páginas — Todo lo que necesitas resuelto.
        </p>
      </div>

      <p className="mx-auto mb-10 max-w-2xl text-center text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-224" data-mp="3k8tf5qhethhk">
        Ya sea que estés comenzando con Flores de Bach o que ya atiendas pacientes y quieras hacerlo con más criterio,
        seguridad y estructura profesional,{' '}
        <strong className="text-brand-greenMid" data-id="element-225" data-mp="bs8320the8a8">el Botiquín Bach fue creado para ti</strong>.
      </p>

      <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-2" data-id="element-226" data-mp="6tnckt4172yz">
        {tomes.map((tome, index) => {
        const Icon = tomeIcons[index] ?? BookOpenIcon;
        return <article key={tome.label} className="paper-panel flex h-full flex-col rounded-3xl p-6 md:p-8" data-id="element-227" data-mp="lol63pax1yhn" data-mpi={index}>
              <div className="mb-5 flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-228" data-mp="gpqgo4ig1bok">
                <div className="mx-auto w-36 shrink-0 sm:mx-0 sm:w-40" data-id="element-229" data-mp="2nk50n44wkccw">
                  <div className="overflow-hidden rounded-xl border border-brand-green/15 bg-white shadow-[0_10px_24px_rgba(14,42,30,.14)]" data-id="element-230" data-mp="2ik96rxpx61b2">
                    <img src={tome.cover} alt={tome.coverAlt} loading="lazy" className="block h-auto w-full" draggable={false} data-id="element-231" data-mp="389fwyyl5w261" />
                  </div>
                </div>
                <div className="min-w-0 flex-1" data-id="element-232" data-mp="3h6gj0ykrdo6b">
                  <div className="mb-2 flex items-center gap-2" data-id="element-233" data-mp="3m7e0ta1uwg7a">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-green text-brand-goldLight ring-1 ring-brand-gold/40" data-id="element-234" data-mp="3m4i23ji6pnhs">
                      <Icon className="h-4 w-4" data-id="element-235" data-mp="3v683ni5s62ta" />
                    </span>
                    <p className="text-[11px] font-bold tracking-[.18em] text-brand-goldDark" data-id="element-236" data-mp="3slk810tsheu">{tome.label}</p>
                  </div>
                  <h3 className="font-serif text-xl font-bold leading-tight text-brand-green md:text-2xl" data-id="element-237" data-mp="8rgeq085nues">
                    {tome.title}
                  </h3>
                  <p className="mt-1.5 text-xs italic leading-snug text-brand-muted md:text-sm" data-id="element-238" data-mp="ipmas17a66bq">{tome.subtitle}</p>
                  <div className="leaf-rule mt-4" aria-hidden="true" data-id="element-239" data-mp="2397y3uq4v652" />
                </div>
              </div>
              <ul className="space-y-2.5 text-sm leading-snug text-brand-text" data-id="element-240" data-mp="1y8aldxnw74ay">
                {tome.features.map(feature => <li key={feature} className="flex gap-2.5" data-id="element-241" data-mp="1taip6rg7sw0y">
                    <span className="font-bold text-brand-greenMid" data-id="element-242" data-mp="1obpe15oehh3y">✓</span>
                    <span data-id="element-243" data-mp="2lyemnydlyrys">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-14 text-center" data-id="element-244" data-mp="2gzbew668u7n4">
        <h3 className="font-serif text-xl font-bold text-brand-green md:text-2xl" data-id="element-245" data-mp="2h1o6zc5ptydw">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-246" data-mp="2c6iaxkiln3c3">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-id="element-247" data-mp="277xmeicpm83h">
        {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-brand-green/20 bg-brand-parchment text-center" data-id="element-248" data-mp="2zyfkf4yktja1">
            <div className="relative aspect-[5/7] w-full overflow-hidden bg-white" data-id="element-249" data-mp="2keuvhpubvmf0">
              <img src={bonus.cover} alt={`Portada del Bonus ${bonus.number}: ${bonus.title}`} loading="lazy" className="h-full w-full object-cover object-top" draggable={false} data-id="element-250" data-mp="2pgafrfoolowc" />
              <span className="absolute left-2 top-2 rounded-full bg-brand-green px-2.5 py-1 text-[9px] font-bold tracking-wide text-brand-goldLight" data-id="element-251" data-mp="2fgjkhbsar5v7">
                BONUS {bonus.number}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-3" data-id="element-252" data-mp="384p8q8ik7czs">
              <p className="text-[13px] font-bold leading-tight text-brand-text" data-id="element-253" data-mp="2thdt9vj9b8ue">{bonus.title}</p>
              <p className="mt-auto pt-2 text-[11px] font-semibold text-brand-goldDark" data-id="element-254" data-mp="2yfxkaacpjatm">{bonus.pages}</p>
            </div>
          </article>)}
      </div>

      <div className="mt-8 text-center" data-id="element-255" data-mp="3m48a8igv7q34">
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-256" data-mp="3qw87u49gq6wj">
          Todo el valor de los bonus <span className="font-bold text-brand-greenMid" data-id="element-257" data-mp="1ffojdnpoh1bl">incluido con tu Botiquín Bach</span>
        </p>
      </div>
    </Section>;
}